/**
 * Amber note when an invoice charges VAT in a currency other than the
 * organisation's own. The invoice stays in its currency (no exchange rates are
 * kept), but the VAT return is filed in the home currency, so most tax
 * authorities expect the VAT amount stated in it as well.
 */
export function ForeignVatNotice({
  currency,
  orgCurrency,
  vatTotal,
}: {
  currency: string | null | undefined;
  orgCurrency: string | null | undefined;
  vatTotal: number;
}) {
  if (!currency || !orgCurrency || vatTotal === 0) return null;
  if (currency.toUpperCase() === orgCurrency.toUpperCase()) return null;
  return (
    <p className="mb-2 rounded-md border border-amber-200 bg-amber-50 px-3 py-1.5 text-[11px] font-medium text-amber-800">
      VAT is charged in {currency.toUpperCase()}, but your VAT return is in {orgCurrency.toUpperCase()} — the
      VAT amount usually has to be shown in {orgCurrency.toUpperCase()} as well. Check the rate on the line
      (a foreign customer is often 0%), or add the converted VAT to the message.
    </p>
  );
}
